// extracted by mini-css-extract-plugin
module.exports = {"subtext":"PaymentMethodSelector_subtext__N26Kh","paymentMethods":"PaymentMethodSelector_paymentMethods__cQuOL"};